// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","134":"a84a90cf","357":"e49bcc2e","995":"b2aa14dc"}[chunkId] + ".js";
};